export default {
  loadingFirstMessage: 'Just a moment, the designer is loading.',
  checking: 'Checking...',
  cash: 'Cash',
  toLogin: 'Go to login',
  payoff: 'for when you grow up',
  login: 'Log in',
  loginForgot: 'forgot',
  loginIntro: 'First, create an account or log in if you already have one.',
  loginFailed: 'Login failed',
  loginNoAccount: 'I don’t have an account',
  loginSendNew: 'Send me a new login',
  accountCreate: 'Create an account',
  accountAlready: ' Already have an account? Log in here',
  voucherPersonalCode: 'I have a personal code',
  voucherIntro:
    'Enter your personal code. You can find the code on the back of your voucher or in the confirmation email.',
  voucherInvalid: 'Enter a valid code of 15 characters including dashes. For example, 2Wpa-SFtB-999c.',
  backToLogin: 'Back to login screen',
  passwordRequest: 'Send me a new login',
  passwordRequestSend: 'An email has been sent with further instructions.',
  passwordRequestRemember: 'Remember your password?',
  childIntro: 'First, enter the name and birthdate of your child. They will already be added for you.',
  menuAccount: 'account',
  menuOrder: 'order',
  menuChild: 'child',
  menuDesigns: 'designs',
  menuPhotos: 'edit',
  menuHelp: 'help',
  photosChooseMore: 'Choose more photos',
  photosChoose: 'Choose your photos',
  assignmentSelectPhotosFirst: 'Read your photos first',
  assignmentSelectPhotos: 'Read photos',
  assignmentClose: 'Close film roll',
  notificationReady: 'Hooray! You are done. --- Double-check all text and photos carefully.',
  notificationGoToOrder: 'Go to order',
  orderUnfinishedFirstPart:
    'You cannot order yet. First, add photos and text everywhere. If you still see a yellow dot, you need to add something. If all dots are green, double-check your work. Have fun!',
  orderUnfinishedSecondPart: ' Have fun !',
  orderIntro: 'Enter your address.',

  kidSectionTtitle: 'Child',
  childBookTargetInput: 'This book is for:',
  childBookStartButtonOption1: 'Add a child',
  childBookStartButtonOption2: 'Add another child',
  childBookTargetOption1: 'Who are you making the book for:',
  childBookTargetOption2: 'Or make it for your other child:',
  childFormInputNameLabel: 'First Name',
  childFormInputNamePlaceholder: 'Your child’s first name',
  childFormInputLettersInformation: 'Cannot be longer than 12 characters',
  childFormInputDateLabel: 'Date of Birth',
  backButton: 'Back',
  getStartedButton: 'Get started',

  cameraRollTab: 'Camera roll',
  pinupTab: 'Pinboard',
  savedPhotosInformation: 'Saved photos to use in other assignments',

  designInformations: 'Try out the designs. Your work won’t be lost.',

  photoDoesntUploadAlert: 'One photo was not uploaded because it is too large (max 60 MB) or not in JPG format.',
  photoDoesntUploadAlertPlural:
    'There are {rejectedFiles} photos not uploaded because they are too large (max 60 MB) or not in JPG format.',
  callToUseThePhotos: 'Release to use your photos',

  personalGiftCodeLabel: 'Your personal code',
  cachedVoucherTitle: 'Redeem voucher',

  loginCredentialsTitle: 'Log in to your account',
  loginEmailInputLabel: 'Email address',
  loginErrorMessage: 'You cannot log in with an administrator account',
  loginPasswordInput: 'Password',
  forgotPasswordSectionTitle: 'Forgot Password',
  forgotPasswordEmailPlaceholder: 'Your email address',
  makeAccountTitleStep1: 'Create Account (1/2)',
  signupFirstNameInputLabel: 'Your First Name',
  signupFirstNamePlaceholder: 'First Name',
  signupEmailInputLabel: 'Your email address',
  signupPasswordInputLabel: 'Choose a password',
  acceptPrivacyStatementFirstPart: 'I agree to the ',
  acceptPrivacyStatementSecondPart: 'terms and privacy statement',

  smallScreensMessage1: 'Unfortunately, Kroost is not available for mobile or smaller devices yet.',
  smallScreensMessage2: 'Are you on your laptop or desktop? Make your browser screen as large as possible.',

  rotate: 'Rotate',
  mirror: 'Mirror',
  zoomIn: 'Zoom In',
  zoomOut: 'Zoom Out',

  warningToAdjustPhotoPart1: 'To achieve good print quality, you need to adjust this photo.',
  warningToAdjustPhotoPart2: 'What can I do?',

  logout: 'Log out',
  account: 'Account',
  loading: 'Loading...',
  openNewBook: 'Open a new book',

  logout2: 'Logout',

  notReadyMessagePart1: 'Before you can order, you need to ',
  notReadyMessagePart2: 'create an account',
  notReadyMessagePart3: ', so we can process the photos',
  uploadingPhotosMessage: 'Not all photos have been uploaded yet',
  loading2: 'Loading...',
  backToPay: 'Back to payment',
  surname: 'Surname',
  street: 'Street',
  houseNumber: 'House Number',
  postCode: 'Postcode',
  city: 'City',
  country: 'Country',
  phone: 'Phone Number',
  amount: 'Amount',
  warningMessageBeforeForNoChanges: 'You can no longer modify this order',
  fillTheFieldsMessage: 'Fill the red fields to proceed',
  checking2: 'Checking...',
  orderComplete: 'Complete Order',
  orderTitle: 'Order',

  preferdName: ' Preferred Name',
  dateOfBirth: 'Born on (expected)',
  makeYourBook: 'Make Your Book',

  failedUploadWarning:
    'Unfortunately, something went wrong with uploading the photos. If this continues to happen, please contact us.',
  uploandingFaliedMessage: 'Uploading {fileName} failed',
  feedbackUploadingMessage: '{fileName} is being uploaded',
  uploadSuccessMessage: '{fileName} has been uploaded',

  usedPhotoMessageSingular: 'This photo is used in 1 place',
  usedPhotoMessagePlural: 'This photo is used in {count} places',

  newPasswordLabel: 'New password',
  newPasswordPlaceholder: 'Your new password',
  formErrorMessage: ' Password reset failed, the link is only valid for 24 hours. Request again.',
  passwordButtonSubmit: 'Change password',

  saveSuccessTitle: 'Create Account (2/2)',
  enterTheNameOfChildButton: 'Enter your child’s name',
  saveSuccessMessagePart1: 'Your account has been created. All changes are automatically and immediately saved.',
  saveSuccessMessagePart2: 'Enjoy!',
  netherlands: 'Netherlands',
  belgium: 'Belgium',
  germany: 'Germany',
  austria: 'Austria',
  paymentWaitingMessage: 'The payment has been aborted or failed. Go back to payment to pay again.',
  paymentFailedMessage: 'The payment has been aborted or failed. Go back to payment to pay again.',
  paymentSuccessMessagePart1:
    'We are working on it for you. Check your email for confirmation. Just a little more waiting, then enjoy!',
  greetings: 'Cheerful greetings,',
  teamKroost: 'Team Kroost',
  shippingSendMessagePart1:
    "Your order has been sent by letter post. So, you don't have to stay at home. Just a little more waiting, then you can start enjoying!",
  shippingReceivedMessage: '  Your order has been delivered. Enjoy!',
  mergingPhotos: '{mergedPhotos} out of the {photos} photos read',
  doneNotificationMessage: '{mergedPhotos} photos read',
  notUsedPhotosMessage: ' - {notused} ignored',
  year: 'year',
  months: 'month',
  monthsPlural: 'months',
  day: 'day',
  days: 'days',
  week: 'week',
  weekPlural: 'weeks',
  birthday: 'Birthday!',
};



// WEBPACK FOOTER //
// ./app/languages/en.js